export default "assets/images/icons/accident-90455755.svg";